import { useEffect } from "react";
import { Link } from "react-router-dom";
import "../page.css";
import "../home.css";

function SafariStub({
  title,
  eyebrow = "Safaris",
  lead,
  points = [],
  parentTo = "/safaris",
  parentLabel = "Safaris",
}) {
  useEffect(() => {
    document.title = `${title} · Mirrorkhan Tours`;
  }, [title]);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row g-4" data-reveal="true">
          <div className="col-lg-8">
            <p className="eyebrow">
              <Link to={parentTo} className="text-decoration-none">
                {parentLabel}
              </Link>
            </p>
            <h1 className="mb-3">{title}</h1>
            <p className="page-lead mb-4">{lead}</p>
            {points.length > 0 ? (
              <ul className="mb-4">
                {points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            ) : null}
            <Link className="btn btn-mk-gold" to="/contact">
              Ask about this safari
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SafariStub;
